<template>
  <div class="PerformanceQuery">
    <div class="queryContent">
      <el-row>
        <el-col>
          <el-form :inline="true" :model="formInline" class="demo-form-inline wordorder-form">
            <el-form-item style="marginRight: 0;" label="From ：" label-width="120px">
              <el-col>
                <el-date-picker type="datetime" @change="getStartTime($event)" placeholder="Please select time" v-model="formInline.beginDate" style="width: 100%;"></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item style="marginRight: 0;" label="To ：" label-width="120px">
              <el-col>
                <el-date-picker type="datetime" @change="getEndTime($event)" placeholder="Please select time" v-model="formInline.endDate" style="width: 100%;"></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="Insurance Branch：" label-width="150px">
              <el-cascader :options="saleBarnchs" placeholder="Please select insurance branch" clearable v-model="formInline.branchId" @change="onSaleBarnchChange">
              </el-cascader>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="querybtn" @click="getDataList(1)" style="position:absolute;">Search</el-button>
            </el-form-item>
            <el-col class="lastform">
              <el-form-item label="Operator：" label-width="120px">
                <el-select v-model="formInline.agentId" placeholder="Please select operator" clearable @change="getDataList(1)">
                  <el-option v-for="item in personOptions" :key="item.agentId" :label="item.agentName" :value="item.agentId">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Passport No.：" label-width="120px">
                <el-input v-model="formInline.idNo" placeholder="Search by Passport Number"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
        </el-col>
      </el-row>
    </div>
    <div class="totalrecord">Result of
      <span class="lineheightfont">{{totalLine}} </span>
    </div>
    <div style="height:618px; overflow:auto;" @scroll="onScroll($event)" ref="tableWrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading" class="perform-table">
        <el-table-column prop="approveDate" label="Insurance time">
        </el-table-column>
        <el-table-column prop="branchName" label="Insurance Branch">
        </el-table-column>
        <el-table-column prop="idNo" label="Passport No.">
        </el-table-column>
        <el-table-column prop="name" label="Name">
        </el-table-column>
        <el-table-column prop="policyStatus" label="Policy Status">
        </el-table-column>
        <el-table-column prop="periodTotalPremium" label="Payment from Customer">
        </el-table-column>
        <el-table-column prop="agentName" label="Operator">
        </el-table-column>
        <el-table-column prop="agentCode" label="Operator ID ">
        </el-table-column>
        
      </el-table>
    </div>

  </div>
</template>
<script>

import INTERFACE from '../../interface'
import fecha from 'fecha'
//  import globalConfig from '../../config'

export default {
  components: {
  },
  data() {
    return {
      I18n: window.I18n,
      loading: false,
      totalLine: 0,
      isBottom: false,
      queryObj: {
        beginDate: '',
        endDate: '',
        branchId: [],
        agentId: '',
        idNo: '',
        currentPage: 1,
        pageSize: 30
      },
      formInline: {
        beginDate: '',
        endDate: '',
        branchId: [],
        agentId: '',
        idNo: ''
      },
      saleBarnchs: [],
      personOptions: [],
      tableData: []
    }
  },
  created() {
    INTERFACE.getfinanceList({ currentPage: 1, pageSize: 30 }).then(data => {
      this.loading = false
      this.totalLine = data.data.totalLine
      if (data.data.data && data.data.data.length > 0) {
        data.data.data.forEach(item => {
          item.approveDate = this.getTime(item.approveDate)
        })
        this.tableData = data.data.data
      } else {
        this.tableData = []
      }
    })
    INTERFACE.getagentNameList().then(data => {
      this.isBottom = false
      if (data.data && data.data.length > 0) {
        this.personOptions = data.data
      } else {
        this.personOptions = []
      }
    })
    // 获取机构列表
    INTERFACE.getbranchList().then(data => {
      this.saleBarnchs = data.data[0].childs;
      const getOptions = function(data, valueAlias, labelAlias) {
        let res = [];
        data.forEach((t, index) => {
          res[index] = {
            value: t[valueAlias],
            label: t[labelAlias]
          }
          if (t.childs && t.childs.length) {
            res[index].children = getOptions(t.childs, valueAlias, labelAlias);
          }
        })
        return res;
      };
      this.saleBarnchs = getOptions(data.data, 'branchId', 'branchName');
    });
  },
  methods: {
    getDataList(val) {
      this.isBottom = false
      this.queryObj.currentPage = 1
      this.queryObj.agentId = this.formInline.agentId
      this.queryObj.idNo = this.formInline.idNo
      INTERFACE.getfinanceList(this.queryObj).then(data => {
        this.loading = false
        this.totalLine = data.data.totalLine
        if (data.data.data && data.data.data.length > 0) {
          data.data.data.forEach(item => {
            item.approveDate = this.getTime(item.approveDate)
          })
          this.tableData = data.data.data
        } else {
          this.tableData = []
        }
      })
    },
    getTime(value) {
      if (value && value !== 0) {
        const date = new Date(+value);
        return fecha.format(date, 'YYYY-MM-DD HH:mm')
      }
    },
    getTableConcatList() {
      this.queryObj.agentId = this.formInline.agentId
      this.queryObj.idNo = this.formInline.idNo
      if (this.isBottom) return
      INTERFACE.getfinanceList(this.queryObj).then(data => {
        this.loading = false
        if (data.data.data && data.data.data.length > 0) {
          data.data.data.forEach(item => {
            item.approveDate = this.getTime(item.approveDate)
          })
          this.tableData = this.tableData.concat(data.data.data);
        } else {
          this.isBottom = true
        }
      })
    },
    onScroll(event) {
      if (this.isBottom) return
      if (event.target.scrollTop + event.target.clientHeight === event.target.scrollHeight) {
        this.loading = true
        this.queryObj.currentPage += 1
        this.getTableConcatList()
      }
    },
    getStartTime(value) {
      if (value) {
        this.queryObj.beginDate = Date.parse(new Date(value))
      } else {
        this.queryObj.beginDate = ''
      }
    },
    getEndTime(value) {
      if (value) {
        this.queryObj.endDate = Date.parse(new Date(value))
      } else {
        this.queryObj.endDate = ''
      }
    },
    handleChange() {

    },
    onSaleBarnchChange(arr) {
      // let resObj = {};
      let curObj = this.saleBarnchs;
      arr.forEach((t, index) => {
        curObj = curObj.find(it => it.value === t);
        if (curObj.children) curObj = curObj.children;
        // if (index === arr.length - 1 && curObj) resObj = curObj;
      })
      this.queryObj.branchId = curObj.value
      this.getDataList()
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import "index.styl"
</style>



// WEBPACK FOOTER //
// src/pages/PerformanceQuery/index.vue